import { render, staticRenderFns } from "./TournamentDetails.vue?vue&type=template&id=36141c95&scoped=true"
import script from "./TournamentDetails.vue?vue&type=script&lang=js"
export * from "./TournamentDetails.vue?vue&type=script&lang=js"
import style0 from "./TournamentDetails.vue?vue&type=style&index=0&id=36141c95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36141c95",
  null
  
)

export default component.exports